import React, { useState } from 'react';
import { TextLink } from '@dsg-tech/homefield-react';
import { checkStores, setDataEmTag } from '../../../../utility/utility';
import { KEY_CODES } from '../../../../utility/constants';
import AccordionFooter from '../AccordionFooter/AccordionFooter';
import FooterSocialLinks from '../FooterSocialLinks/FooterSocialLinks';
import MJFooterSocialLinks from '../MJFooterSocialLinks/MJFooterSocialLinks';
import './FooterLinks.scss';

export default function FooterLinks({ footerLinksData, storeIdentifierName }) {
  const [currentAccordionIndex, setCurrentAccordionIndex] = useState<number>();

  const footerAccordionHandler = (index: number, accordionData: any) => {
    if (accordionData.col) {
      if (currentAccordionIndex === index) {
        setCurrentAccordionIndex(-1);
      } else {
        setCurrentAccordionIndex(index);
      }
    } else {
      setCurrentAccordionIndex(-1);
      window.location.href = accordionData.u;
    }
  };

  const accordionClickHandler = (index: number, accordionData: any) => {
    footerAccordionHandler(index, accordionData);
  };

  const accordionKeyEventHandler = (
    index: number,
    accordionData: any,
    event?: React.KeyboardEvent,
  ) => {
    if (event?.keyCode === KEY_CODES.ENTER || event?.keyCode === KEY_CODES.SPACE) {
      event.preventDefault();
      footerAccordionHandler(index, accordionData);
    } else {
      setCurrentAccordionIndex(-1);
    }
  };

  return (
    <div className="footerLinks-container hmf-display-flex hmf-py-m-xl hmf-px-m-m">
      {footerLinksData.map((linkCats: any, index: number) => {
        const hasColumnData =
          linkCats.col && linkCats.col.length >= 1 && linkCats.col[0] && linkCats.col[0].cats;
        return (
          <React.Fragment key={linkCats.n}>
            <div className="hmf-display-m-none">
              <AccordionFooter
                accordionCatData={linkCats}
                storeIdentifierName={storeIdentifierName}
                footerAccordionHandler={footerAccordionHandler}
                accordionIndex={index}
                openAccordion={index === currentAccordionIndex}
                accordionClickHandler={accordionClickHandler}
                accordionKeyEventHandler={accordionKeyEventHandler}
              />
            </div>
            <div className="footerLinks-container__linkCol">
              <h2 className="footerLinks-container__linkCol--heading hmf-body-bold-l hmf-text-transform-uppercase hmf-mt-m-0">
                {linkCats.n}
              </h2>
              {hasColumnData
                ? linkCats.col[0].cats.map((links: any) => (
                    <span key={links.n}>
                      <TextLink
                        variant="group-inverse"
                        size="small"
                        href={checkStores(links.u)}
                        target={checkStores(links.u).includes('http') ? '_blank' : '_self'}
                        rel={checkStores(links.u).includes('http') ? 'noreferrer' : ''}
                        data-em={setDataEmTag('Footer', links.n)}>
                        {links.n}
                      </TextLink>
                    </span>
                  ))
                : null}
            </div>
          </React.Fragment>
        );
      })}
      {storeIdentifierName === 'pl' ? <FooterSocialLinks /> : <MJFooterSocialLinks />}
    </div>
  );
}
